import { datadogRum } from "@datadog/browser-rum";
import { ErrorMessageWithActions } from "PFComponents/error_message";
import { ErrorInfo, ReactNode } from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

import css from "./error_boundary.module.scss";

type ErrorBoundaryProps = {
  children?: ReactNode;
};

const FallBackComponent = () => <ErrorMessageWithActions className={css.container} />;

export const ErrorBoundary = ({ children }: ErrorBoundaryProps) => {
  const handleError = (error: Error, errorInfo: ErrorInfo) => {
    if (datadogRum) {
      datadogRum.addError(error, errorInfo);
    }
  };

  return (
    <ReactErrorBoundary onError={handleError} FallbackComponent={FallBackComponent}>
      {children}
    </ReactErrorBoundary>
  );
};
